import classnames from 'classnames'

import Fixture from '~/components/atoms/Fixture/Fixture'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import Container from '../Container/Container'
import { Col, Grid, Row } from '../Grid'
import type { ImageProps } from '../Image/Image'
import Image from '../Image/Image'

import styles from './FullWidthImage.module.css'

export interface FullWidthImageProps {
  image: ImageProps
  variant?: ComponentTheme
  testID?: string
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  moduleId?: string
}

export default function FullWidthImage({
  image,
  variant = ComponentTheme.primary,
  testID,
  verticalPadding,
  noPaddingBottom,
  moduleId,
}: FullWidthImageProps) {
  const themes: any = {
    primary: {
      credit: TextSizes.tertiaryTitleSml,
    },
    secondary: {
      credit: TextSizes.tertiaryTitleSml,
    },
    magazine: {
      credit: TextSizes.magSecondaryBodySml,
    },
    black: {
      credit: TextSizes.magSecondaryBodySml,
    },
  }

  return (
    <div
      className={classnames(styles.base, styles[variant])}
      data-testid={testID}
      id={moduleId}
    >
      <Fixture
        verticalPadding={verticalPadding}
        noPaddingBottom={noPaddingBottom}
      >
        <Image
          asset={image.asset}
          objectFit="cover"
          alt={image.text}
          className={styles.image}
        />

        {image.credit?.text && (
          <Container>
            <Grid>
              <Row>
                <Col>
                  <Text
                    className={classnames(styles.imageCredit, {
                      [styles[image.credit.theme]]: image.credit.theme,
                    })}
                    size={themes[variant].credit}
                  >
                    {image.credit.text}
                  </Text>
                </Col>
              </Row>
            </Grid>
          </Container>
        )}
      </Fixture>
    </div>
  )
}
